export default __webpack_public_path__ + "static/education-equity-accomplishment-3-c7e0e7dd20e17e3cd6a2d488a523e287.webp";